<div class="flex-control flex-column">
  <app-tabs>
    <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()">Patients</li>
  </app-tabs>
  <app-patients-filter class="flex-control flex-column" [hidden]="tabs_service.is_active()" (sender)="add_to_tabs($event)"></app-patients-filter>
</div>
